import type { AxiosInstance, AxiosRequestConfig } from 'axios';

interface NextFetchCacheOptions {
  /**
   * @description time-based 방식의 캐시 재검증을 위한 초 단위 시간 또는 false 로 재검증 비활성화 (nextjs fetch 함수에서 제공하는 next.revalidate 옵션)
   * @link { https://nextjs.org/docs/app/building-your-application/data-fetching/fetching-caching-and-revalidating#revalidating-data }
   */
  revalidate?: number | false;

  /**
   * @description on-demand 방식의 캐시 재검증을 위한 식별 가능한 string 키 배열 (nextjs fetch 함수에서 제공하는 next.tags 옵션)
   * @link { https://nextjs.org/docs/app/building-your-application/data-fetching/fetching-caching-and-revalidating#on-demand-revalidation }
   */
  tags?: string[];
}

interface HttpClientCacheOptions {
  /**
   * @description 캐시 정책 (fetch 함수에서 제공하는 기본 cache 정책 옵션)
   * @link { https://nextjs.org/docs/app/building-your-application/data-fetching/fetching-caching-and-revalidating#caching-data }
   */
  cache?: RequestCache;
  next?: NextFetchCacheOptions;
}

export interface HttpMethodsConfig extends AxiosRequestConfig {
  cache?: HttpClientCacheOptions;
}

export const createHttpClient = (instance: AxiosInstance) => ({
  get: <T>(url: string, parameters?: unknown, config?: HttpMethodsConfig) =>
    instance.get<T>(url, { ...config, params: parameters, fetchOptions: config?.cache }),
  post: <T, D = Record<string, unknown>>(url: string, data?: D, config?: HttpMethodsConfig) =>
    instance.post<T>(url, data, config),
  put: <T, D = Record<string, unknown>>(url: string, data?: D, config?: HttpMethodsConfig) =>
    instance.put<T>(url, data, config),
  patch: <T, D = Record<string, unknown>>(url: string, data?: D, config?: HttpMethodsConfig) =>
    instance.patch<T>(url, data, config),
  delete: <T>(url: string, parameters?: unknown, config?: HttpMethodsConfig) =>
    instance.delete<T>(url, { params: parameters, ...config }),
});
